/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";

export type GetAvatarGravatarRequest = {
  email?: string | undefined;
  hash?: string | undefined;
  s?: number | undefined;
  d?: string | undefined;
  r?: string | undefined;
};

export const GetAvatarGravatarRequest$zodSchema: z.ZodType<
  GetAvatarGravatarRequest
> = z.object({
  d: z.string().default("mp").describe(
    "当用户没有自己的 Gravatar 头像时，显示的默认头像类型。可选值包括 `mp`, `identicon`, `monsterid`, `wavatar`, `retro`, `robohash`, `blank`, `404`。",
  ),
  email: z.string().describe(
    "用户的 Email 地址。如果未提供 `hash` 参数，则此参数为必需。",
  ).optional(),
  hash: z.string().describe(
    "用户 Email 地址的小写 MD5 哈希值。如果提供此参数，将忽略 `email` 参数。",
  ).optional(),
  r: z.string().default("g").describe(
    "头像分级。可选值：`g`, `pg`, `r`, `x`。",
  ),
  s: z.int().default(80).describe(
    "头像的尺寸，单位为像素。有效范围是 1 到 2048。",
  ),
});

/**
 * 当 `d=404` 且请求的 email 或 hash 没有对应的 Gravatar 头像时。
 */
export type GetAvatarGravatarNotFoundResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetAvatarGravatarNotFoundResponseBody$zodSchema: z.ZodType<
  GetAvatarGravatarNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("当 `d=404` 且请求的 email 或 hash 没有对应的 Gravatar 头像时。");

/**
 * 当请求中既没有提供 `email` 也没有提供 `hash` 参数时。
 */
export type GetAvatarGravatarBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetAvatarGravatarBadRequestResponseBody$zodSchema: z.ZodType<
  GetAvatarGravatarBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("当请求中既没有提供 `email` 也没有提供 `hash` 参数时。");

export type GetAvatarGravatarResponseResult =
  | Uint8Array
  | string
  | GetAvatarGravatarBadRequestResponseBody
  | GetAvatarGravatarNotFoundResponseBody;

export const GetAvatarGravatarResponseResult$zodSchema: z.ZodType<
  GetAvatarGravatarResponseResult
> = z.union([
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
  z.lazy(() => GetAvatarGravatarBadRequestResponseBody$zodSchema),
  z.lazy(() => GetAvatarGravatarNotFoundResponseBody$zodSchema),
]);

export type GetAvatarGravatarResponse = {
  Headers: { [k: string]: Array<string> };
  Result:
    | Uint8Array
    | string
    | GetAvatarGravatarBadRequestResponseBody
    | GetAvatarGravatarNotFoundResponseBody;
};

export const GetAvatarGravatarResponse$zodSchema: z.ZodType<
  GetAvatarGravatarResponse
> = z.object({
  Headers: z.record(z.string(), z.array(z.string())).default({}),
  Result: z.union([
    z.string().describe("Base64-encoded binary content").transform(
      b64$.bytesFromBase64,
    ),
    z.lazy(() => GetAvatarGravatarBadRequestResponseBody$zodSchema),
    z.lazy(() => GetAvatarGravatarNotFoundResponseBody$zodSchema),
  ]),
});
